import React, { useEffect, useMemo, useState } from "react";
import {
  BlackBorder,
  Button,
  Container,
  FormContainer,
  InputContainer,
  TextContainer,
  ResetSearchContainer,
} from "./styled-component";
import Text from "../text";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { ReactComponent as CrossIcon } from "../../assets/icons/cross.svg";
import { getPlaceholder } from "../../helper/placeholder";

const SearchBar = ({
  onSearchValue,
  searchedValue,
  handleSearchResults,
  onDeleteSearch,
  domain = "",
}: SearchBarProps) => {
  const [searchInit, setSearchInit] = useState(false);
  const [isButtonActive, setIsButtonActive] = useState(false);

  const placeholder = useMemo(() => getPlaceholder(domain), [domain]);
  return (
    <Container>
      <FormContainer
        isEmpty={!searchedValue}
        searchInit={searchInit}
        onSubmit={(event) => {
          event.preventDefault();
          if (searchedValue) {
            setSearchInit(false);
            setIsButtonActive(false);
            handleSearchResults && handleSearchResults();
          }
        }}
      >
        <BlackBorder searchInit={searchInit}>
          <InputContainer
            isEmpty={!searchedValue}
            searchInit={searchInit}
            tabIndex={0}
          >
            <input
              placeholder={placeholder}
              value={searchedValue}
              onFocus={() => {
                setSearchInit(true);
                setIsButtonActive(true);
              }}
              onBlur={() => {
                setSearchInit(false);
                setIsButtonActive(false);
              }}
              onChange={(event) => {
                onSearchValue && onSearchValue(event.target.value);
                setSearchInit(false);
                setIsButtonActive(true);
              }}
            />

            <div>
              {searchedValue && (
                <ResetSearchContainer
                  onClick={() => {
                    onDeleteSearch && onDeleteSearch();
                    setSearchInit(false);
                  }}
                >
                  <TextContainer>
                    <Text underline color="grey400" size="16px" weight={700}>
                      Effacer la recherche
                    </Text>
                  </TextContainer>
                  <CrossIcon />
                </ResetSearchContainer>
              )}
            </div>
          </InputContainer>
        </BlackBorder>
        <div tabIndex={1}>
          <Button type="submit" isDisabled={!isButtonActive}>
            <SearchIcon />
            <p>Rechercher</p>
          </Button>
        </div>
      </FormContainer>
    </Container>
  );
};

export default SearchBar;
